/**
 * One outline set at 24 px with a 1.75 px stroke (docs/52 §4.7). Icons are decorative: every icon sits beside a
 * visible label, so they're aria-hidden and never carry meaning alone.
 */
import type { JSX } from 'preact';

const P: Record<string, string> = {
  home: 'M3.5 10.5 12 4l8.5 6.5M5.5 9v10.5h5v-6h3v6h5V9',
  leads: 'M4 5h16v11H14l-4 3.5V16H4z M8 9.5h8 M8 12.5h5',
  reviews: 'm12 3.8 2.5 5.1 5.6.8-4 4 .9 5.6-5-2.7-5 2.7.9-5.6-4-4 5.6-.8z',
  jobs: 'M4 8h3l1.5-2.5h7L17 8h3v11H4z M12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
  inbox: 'M4 13.5 6.5 5h11l2.5 8.5V19H4z M4 13.5h4.5l1 2h5l1-2H20',
  bell: 'M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5h-15z M10 20.5h4',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4.5 20c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5',
  users: 'M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M2.5 19.5c.9-3.1 3.3-4.8 6.5-4.8s5.6 1.7 6.5 4.8 M15.5 4.8a3.4 3.4 0 0 1 0 6.4 M17.5 14.9c2 .6 3.4 2.2 4 4.6',
  'chevron-right': 'm9.5 6 6 6-6 6',
  'chevron-left': 'm14.5 6-6 6 6 6',
  'chevron-down': 'm6 9.5 6 6 6-6',
  'chevron-up': 'm6 14.5 6-6 6 6',
  plus: 'M12 5v14 M5 12h14',
  phone: 'M8.5 3.5 5 4.5C4.3 12.6 11.4 19.7 19.5 19l1-3.5-4.5-2-2 2c-2-1-3.5-2.5-4.5-4.5l2-2z',
  sms: 'M4.5 5.5h15v10h-9l-4 3.5v-3.5h-2z M8.5 10.5h.01 M12 10.5h.01 M15.5 10.5h.01',
  mail: 'M3.5 6h17v12h-17z m0 .5 8.5 7 8.5-7',
  pin: 'M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  check: 'm5 12.5 4.5 4.5L19 7.5',
  x: 'M6 6l12 12 M18 6 6 18',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3.5 2',
  alert: 'M12 4 2.8 19.5h18.4z M12 10v4.5 M12 17.2v.01',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 11v5.5 M12 7.8v.01',
  lock: 'M6 10.5h12v9.5H6z M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5',
  copy: 'M9 9h10.5v11H9z M6 15H4.5V4H15v1.5',
  camera: 'M4 8h3l1.5-2.5h7L17 8h3v11H4z M12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
  image: 'M4 5h16v14H4z M4 16l5-5 4 4 2.5-2.5L20 17 M15.5 9.5h.01',
  mic: 'M12 14.5a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5.5a3 3 0 0 0 3 3z M6.5 11a5.5 5.5 0 0 0 11 0 M12 16.5V20',
  upload: 'M12 15V4.5 M7.5 9 12 4.5 16.5 9 M4.5 15v4.5h15V15',
  download: 'M12 4.5V15 M7.5 10.5 12 15l4.5-4.5 M4.5 15v4.5h15V15',
  refresh: 'M19.5 12a7.5 7.5 0 1 1-2.2-5.3 M19.5 4.5v4h-4',
  offline: 'M3 3l18 18 M8.5 16.5a5 5 0 0 1 7 0 M5 13a10 10 0 0 1 4-2.5 M12 20h.01 M15 10.8a10 10 0 0 1 4 2.2 M2 9.5a14 14 0 0 1 4.3-2.8 M10.5 5.6A14 14 0 0 1 22 9.5',
  'arrow-up': 'M12 19V5 M6 11l6-6 6 6',
  'arrow-down': 'M12 5v14 M6 13l6 6 6-6',
  'arrow-right': 'M5 12h14 M13 6l6 6-6 6',
  external: 'M14 4.5h5.5V10 M19.5 4.5 11 13 M17 14v5.5H4.5V7H10',
  star: 'm12 3.8 2.5 5.1 5.6.8-4 4 .9 5.6-5-2.7-5 2.7.9-5.6-4-4 5.6-.8z',
  share: 'M12 15V4 M8 7.5 12 3.8 16 7.5 M6.5 11H5v9.5h14V11h-1.5',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M19 12l1.8-1.4-1.8-3.2-2.2.7-1.6-1L14.8 4.5h-3.6l-.4 2.6-1.6 1-2.2-.7L5.2 10.6 7 12l-1.8 1.4 1.8 3.2 2.2-.7 1.6 1 .4 2.6h3.6l.4-2.6 1.6-1 2.2.7 1.8-3.2z',
  calendar: 'M4.5 6h15v14h-15z M4.5 10h15 M8.5 3.5V7 M15.5 3.5V7',
  search: 'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z M15.2 15.2 20 20',
  trash: 'M4.5 7h15 M9.5 7V4.5h5V7 M6.5 7l1 13h9l1-13',
  edit: 'M4.5 19.5l1-4.5L15.5 5l3.5 3.5-10 10z M13 7.5l3.5 3.5',
  shield: 'M12 3.5 19 6v5.5c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6z M9 12l2 2 4-4',
  card: 'M3.5 6h17v12h-17z M3.5 10h17 M7 15h3',
  building: 'M5 20.5V4h10v16.5 M15 9h4v11.5 M3.5 20.5h17 M8 7.5h1.5 M11 7.5h1.5 M8 11h1.5 M11 11h1.5 M8 14.5h1.5 M11 14.5h1.5',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M3.5 12h17 M12 3c2.3 2.4 3.5 5.4 3.5 9s-1.2 6.6-3.5 9c-2.3-2.4-3.5-5.4-3.5-9S9.7 5.4 12 3z',
  moon: 'M19.5 14.5A7.5 7.5 0 0 1 9.5 4.5a7.5 7.5 0 1 0 10 10z',
  logout: 'M10 4.5H5v15h5 M14.5 8l4 4-4 4 M18.5 12H9',
  flag: 'M5.5 21V4.5 M5.5 4.5h12l-2.5 4 2.5 4h-12',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  grid: 'M4 4h4v4H4z M10 4h4v4h-4z M16 4h4v4h-4z M4 10h4v4H4z M10 10h4v4h-4z M16 10h4v4h-4z M4 16h4v4H4z M10 16h4v4h-4z M16 16h4v4h-4z',
  undo: 'M9 14 4.5 9.5 9 5 M4.5 9.5h9a6 6 0 0 1 0 12H9',
  send: 'M4 12 20 4.5l-4.5 15-3.5-6.5z M12 13l8-8.5',
  file: 'M6 3.5h8l4 4v13H6z M14 3.5V8h4',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6 M12 17h.01',
  hourglass: 'M7 3.5h10 M7 20.5h10 M8 3.5c0 4.5 4 5 4 8.5s-4 4-4 8.5 M16 3.5c0 4.5-4 5-4 8.5s4 4 4 8.5',
  spark: 'M12 3.5 13.8 10.2 20.5 12l-6.7 1.8L12 20.5l-1.8-6.7L3.5 12l6.7-1.8z',
  wrench: 'M14.5 6.5a4 4 0 0 0-5.3 5.3L4 17v3h3l5.2-5.2a4 4 0 0 0 5.3-5.3l-2.5 2.5-2.5-.5-.5-2.5z',
  dot: 'M12 12h.01',
  menu: 'M4 7h16 M4 12h16 M4 17h16',
  sun: 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z M12 2.5v2 M12 19.5v2 M2.5 12h2 M19.5 12h2 M5.3 5.3l1.4 1.4 M17.3 17.3l1.4 1.4 M5.3 18.7l1.4-1.4 M17.3 6.7l1.4-1.4',
  'map': 'M9 4.5 3.5 6.5v13L9 17.5l6 2 5.5-2v-13L15 6.5z M9 4.5v13 M15 6.5v13',
  qr: 'M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h2v2h-2z M18 14h2v2 M14 18h2v2 M18 18h2v2h-2z',
  receipt: 'M6 3.5h12v17l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5z M9 8h6 M9 11.5h6 M9 15h3.5',
};

export type IconName = keyof typeof P | string;

export function Icon({ name, size = 24, filled = false, class: cls }: { name: IconName; size?: number; filled?: boolean; class?: string }): JSX.Element {
  const d = P[name] ?? P.dot!;
  return (
    <svg
      class={cls}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      stroke-width={1.75}
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}

export const ICON_NAMES = Object.keys(P);
